const rafID = Symbol('rafID')
export default class ImageStage {
  constructor(canvas) {
    this.canvas = canvas
    this.canvasContext = canvas.getContext('2d')
    this.spirits = []
    this.setup()
  }

  setup() {
    this.#runLoop()
  }

  #runLoop() {
    const { width, height } = this.canvas
    const context = this.canvasContext
    const centerX = width  / 2
    const centerY = height / 2
   
    context.clearRect(0, 0, width, height)
    // console.log('update')

    this.spirits.forEach(spirit => {
      spirit.update()
    })
    
    this.spirits.forEach(spirit => {
      spirit.draw(context, centerX, centerY)
    })
    
    this[rafID] = requestAnimationFrame(()=>{
      this.#runLoop()
    })
  }

  stop() {
    cancelAnimationFrame(this[rafID])
    this[rafID] = void 0
  }


  add(spirit) {
    this.spirits.push(spirit)
  }

  remove(spirit) {
    this.spirits = this.spirits.filter((item) => item !== spirit)
  }
}
